import { render } from "./administration.vue?vue&type=template&id=0eee80a5"
import script from "./administration.vue?vue&type=script&lang=ts"
export * from "./administration.vue?vue&type=script&lang=ts"
script.render = render

export default script